<template>
    <div class="home">
        <RibbonDependencies
            class="noselect"
            ref="ribbon"
            :viewMode="viewMode"
            :codeTexts="codeTexts"
            :columns="columns"

            :equipment="equipment"
            :equipments="equipments"
            :serviceType="serviceType"
            :serviceTypes="serviceTypes"
            :layoutType="layoutType"
            :layoutTypes="layoutTypes"
            :layoutValue="layoutValue"

            :componentCodes="componentCodes"
            :surveyTypes="surveyTypes"
            :isoCodes="isoCodes"

            @updateView="updateView"
            @saveDependencies="saveDependencies"
            @exportDependencies="exportDependencies"
            @codeTexts="codeTexts = $event"
        />
        <CedexDependencies
            ref="cedexDependencies"
            :viewMode="viewMode"
            :codeTexts="codeTexts"
            :columns="columns"

            :equipment="equipment"
            :serviceType="serviceType"
            :layoutType="layoutType"
            :layoutValue="layoutValue"
            :layoutValues="this[this.layoutType + 's']"
            :dependencies.sync="dependencies"
            :isoCodeToSurveyTypeName="initialData.isoCodeToSurveyTypeName || null"
            :locationCodePrefixToViewTypeName="initialData.locationCodePrefixToViewTypeName || null"

            :componentCodes="componentCodes"
            :isoCodes="isoCodes"
            :locationCodes="locationCodes"
            :materialCodes="materialCodes"
            :damageCodes="damageCodes"
            :repairCodes="repairCodes"
            :inspectionCriterias="inspectionCriteria"
            :repairAreas="repairAreas"
            :scalings="scalings"
            :codeDescriptions="codeDescriptions"
            :comments="comments"

            @updateView="updateView"
            @filterDependencies="filterDependencies"
            @showMessage="showMessage"
            @updateComment="updateComment"
        />
        <SnackBars
            :messages.sync="messages"
            :timeout="3000000"

            bottom
            light
            class="coa_snack"
            :class="'coa_' + messageBox.type"
        />
    </div>
</template>

<script>
// @ is an alias to /src
import CedexDependencies from '@/components/Dependencies/CedexDependencies.vue';
import RibbonDependencies from '@/components/Ribbon/RibbonDependencies.vue';
import SnackBars from '@/components/SnackBars.vue';
import axios from "axios";
import i18n from '../i18n';
import authorization from "../plugins/authorization";
import { popupShowTime } from "../plugins/constants";

export default {
    name: 'Dependencies',
    components: {
        RibbonDependencies,
        CedexDependencies,
        SnackBars
    },
    created() {
        this.setAllowedColumns();
        this.loadInitialData();
        this.$emit('updateHeaderNavigation', []);
    },
    data: () => ({
        initialData: {},
        messages: [],
        messageBox: {
            show:            false,
            content:         '',
            closeButtonText: 'ok',
            closeTimeout:    -1,
        },
        columns: [
            {id: 'isoCode',              title: 'ISO Code',              visible: true,  width: 168, filter: true, required: true},
            {id: 'locationCode',         title: 'Location Code',         visible: true,  width: 168, filter: true, required: true},
            {id: 'locationDescription',  title: 'Location Description',  visible: false, width: 168},
            {id: 'componentCode',        title: 'Component Code',        visible: true,  width: 168, filter: true, required: true},
            {id: 'componentDescription', title: 'Component Description', visible: false, width: 168},
            {id: 'materialCode',         title: 'Material Code',         visible: true,  width: 168, filter: true, required: true},
            {id: 'materialDescription',  title: 'Material Description',  visible: false, width: 168},
            {id: 'damageCode',           title: 'Damage Code',           visible: true,  width: 168, filter: true, required: true},
            {id: 'damageDescription',    title: 'Damage Description',    visible: false, width: 168},
            {id: 'repairCode',           title: 'Repair Code',           visible: true,  width: 168, filter: true, required: true},
            {id: 'repairDescription',    title: 'Repair Description',    visible: false, width: 168},
            {id: 'repairArea',           title: 'Repair Area',           visible: true,  width: 168, filter: true, required: true},
            {
                id: 'inspectionCriteria',
                title: 'Inspection Criteria',
                visible: true,
                width: 168,
                filter: true,
                required: true
            },
            {id: 'contentParameter', title: 'Content Parameter',   visible: true, width: 193, filter: true},
            {id: 'length',           title: 'Length',              visible: true},
            {id: 'width',            title: 'Width',               visible: true},
            {id: 'time',             title: 'Time',                visible: true},
            {id: 'laborScaling',     title: 'Labor Scaling',       visible: true},
            {id: 'materialScaling',  title: 'Material Scaling',    visible: true},
            {id: 'quantityWeight',   title: 'Quantity\n(Weight)',  visible: true},

            {id: 'csc',              title: 'CSC',                 visible: false},
            {id: 'dppExcluded',      title: 'DPP Excluded',        visible: false},
            {id: 'iir',              title: 'Instant Repair',      visible: false},
            {id: 'combiRepair',      title: 'Combi Repair',        visible: false},
            {id: 'reeferMechanic',   title: 'Reefer Mechanic',     visible: false},
            {id: 'materialList',     title: 'Material List',       visible: false},
            {id: 'singleLine',       title: 'Single Line',         visible: false},
            {id: 'flowAndTdbOnly',   title: 'SC Flow /\nTDB only', visible: false, width: 120},

            {id: 'actions',          title: 'Actions',             visible: true},
            {id: 'history',          title: 'History',             visible: true},
        ],
        currentView: 'CEDEX Settings',
        viewMode: 'sidebar',
        codeTexts: true,

        equipment: 'carcass',
        equipments: [
            {id: 'carcass', name: i18n.t('Carcass')},
            {id: 'machinery', name: i18n.t('Machinery')},
            {id: 'tank', name: i18n.t('Tank')},
        ],

        serviceType: '15',
        serviceTypes: [],

        layoutType: 'surveyType',
        layoutTypes: {
            componentCode: {
                id: 'componentCode',
                name: i18n.t('Component Code'),
            },
            surveyType: {
                id: 'surveyType',
                name: i18n.t('Survey Type'),
            },
            isoCode: {
                id: 'isoCode',
                name: i18n.t('ISO Code'),
            },
        },
        layoutValue: null,

        materialCodes:      {},
        damageCodes:        {},
        repairCodes:        {},
        inspectionCriteria: {},
        repairAreas:        {},
        scalings:           {},
        codeDescriptions:   {},
        comments:           {},

        dependencies:       {},

        sortingColumn:      null,
        sortingDirection:   null,
        filters:            {},
        filterResultType:   'single',

        allowed: {
            allColumns: authorization.isAllowed('Settings/CEDEX Settings/Dependencies/Editor/All Columns'),
        },
    }),
    methods: {
        setAllowedColumns: function()
        {
            for (let i = this.columns.length - 1; i >= 0; i--) {
                let title = this.columns[i].title;
                title = title
                    .replace(/\n/g, " ")
                    .replace('/', '')
                    .replace('  ', ' ');
                if (!this.columnAllowed(title)) {
                    this.columns.splice(i, 1);
                }
            }
        },
        columnAllowed: function(columnName) {
            if (this.allowed.allColumns) {
                return true;
            }
            return authorization.isAllowed('Settings/CEDEX Settings/Dependencies/Editor/Columns/' + columnName);
        },
        loadInitialData: function () {
            axios.get('cedexSettings/getInitialData').then(response => {

                this.initialData        = response.data;
                this.serviceTypes       = response.data.serviceTypes;
                this.materialCodes      = response.data.materialCodes;
                this.damageCodes        = response.data.damageCodes;
                this.repairCodes        = response.data.repairCodes;
                this.inspectionCriteria = response.data.inspectionCriteria;
                this.repairAreas        = response.data.repairAreas;
                this.scalings           = response.data.scalings;
                this.codeDescriptions   = response.data.codeDescriptions;
                this.comments           = response.data.comments;

                return response;
            }).catch(error => {
                console.log(error);
                this.showMessage(i18n.t('Dependencies loading failed.'), 'error', popupShowTime);
            });
        },
        updateView: function (updateType, updateValue, sourceOrOptions) {
            // check for value equality to prevent double function calls
            if (
                updateType !== 'layoutValue' // enable list reload
                && JSON.stringify(this[updateType]) === JSON.stringify(updateValue)
            ) {
                return;
            }
            this[updateType] = updateValue;
            if (updateType !== 'viewMode') {
                this.dependencies = {};
            }
            if (
                updateType === 'layoutValue'
                && sourceOrOptions === 'dependencies'
            ) {
                this.$refs.ribbon.setLayoutValue(updateValue);
            } else if (updateType === 'filters') {
                this.filterResultType = sourceOrOptions ? 'group' : 'single';
                this.filters = Object.assign({}, updateValue); // copy by value to enable later equality check
            }

            if (updateType === 'sortingColumn') {
                this.sortingDirection = sourceOrOptions;
            } else {
                this.sortingColumn    = null;
                this.sortingDirection = null;
            }

            const triggerDataLoadTypes = ['equipment', 'serviceType', 'layoutValue', 'sortingColumn', 'filters'];

            if (triggerDataLoadTypes.includes(updateType)) {

                if (this.layoutValue === null) {
                    this.showMessage(i18n.t('Please select a primary filter value.'), 'success', popupShowTime);
                    return;
                }

                this.$refs.cedexDependencies.showLoading();

                axios.post('cedexSettings/loadCedexDependencies', {
                    containerModule:  this.equipment,
                    serviceType:      this.serviceType,
                    layoutType:       this.layoutType,
                    layoutValue:      this.layoutValue,
                    structure:        'tree',
                    sortingColumn:    this.sortingColumn,
                    sortingDirection: this.sortingDirection,
                    filters:          this.filters,
                    filterResultType: this.filterResultType
                }).then(response => {

                    this.showMessage(i18n.t('Dependencies loaded.'), 'success', popupShowTime);
                    this.$refs.cedexDependencies.hideLoading();
                    this.$refs.cedexDependencies.currentPage = 1;

                    if (
                        response.data.data
                        && response.data.data.length === 0
                    ) {
                        this.dependencies = {};
                    } else {
                        this.dependencies = response.data.data;
                        if (!this.dependencies) {
                            this.dependencies = {};
                        }
                    }
                    window.showBeforeUnload = false;
                });
            }
        },
        saveDependencies: async function () {
            const res = await this.$dialog.confirm({
                text:       i18n.t('Do you really want to save your current settings?'),
                title:      i18n.t('Save CEDEX Dependency'),
                persistent: true,
                actions: {
                    false: 'No',
                    true:  'Yes',
                },
            });

            if (!res) {
                return;
            }

            this.$refs.cedexDependencies.showLoading();
            let data = this.$refs.cedexDependencies.collectData();

            let params = new FormData();
            params.append('containerModule', this.equipment);
            params.append('serviceType',     this.serviceType);
            params.append('layoutType',      this.layoutType);

            params.append(this.layoutType,   this.layoutValue);
            params.append('dataCount',       data.dependencyData.length); // for validation
            params.append('dependencies',    JSON.stringify(data.dependencyData));

            for (let index in data.removedRows) {
                params.append('deleted[]', data.removedRows[index]);
            }

            axios
                .post('cedexSettings/saveCedexDependencies', params)
                .then(response => {
                    this.$refs.cedexDependencies.hideLoading();
                    if (
                        response.status === 200
                        && response.data.success
                    ) {
                        this.showMessage(i18n.t('Dependencies saved.'), 'success', popupShowTime);
                        this.$refs.cedexDependencies.clearValidationErrors();
                        window.showBeforeUnload = false;
                        // reload data
                        this.updateView('layoutValue', this.layoutValue);
                        if (
                            Array.isArray(response.data.truncatedData)
                            && response.data.truncatedData.length > 0
                        ) {
                            this.showMessage(response.data.truncatedData.length + i18n.t(' entries were not saved due duplicate data.'), 'success', 3000);
                        }
                    } else {
                        if (
                            typeof response.data.validationErrors === 'object'
                            && Object.keys(response.data.validationErrors).length > 0
                        ) {
                            this.showValidationErrors(response.data.validationErrors);
                        } else {
                            this.showMessage(i18n.t('Dependencies saving failed.'), 'error', popupShowTime);
                        }
                    }
                })
                .catch(error => {
                    this.$refs.cedexDependencies.hideLoading();
                    this.showMessage(i18n.t('Dependencies saving failed.'), 'error', popupShowTime);
                    console.log(error);
                });
        },
        showValidationErrors(validationErrors) {
            let errorMessages = [
                i18n.t('Dependencies saving failed.'),
                i18n.t('The following errors occurred:'),
            ];
            // errors[errorType => [columndId => lineIndexesArray]]
            if (typeof validationErrors.empty === 'object') {
                Object.keys(validationErrors.empty).forEach((columnId) => {
                    this.columns.forEach((column) => {
                        if (column.id === columnId) {
                            // show lines easier for user
                            let lineNumbers = validationErrors.empty[columnId].map((value) => value + 1);
                            if (lineNumbers.length > 1) {
                                errorMessages.push(column.title + ' is empty in lines ' + lineNumbers.join(', ') + '.');
                            } else {
                                errorMessages.push(column.title + ' is empty in line ' + lineNumbers.join(', ') + '.');
                            }
                        }
                    });
                });
            }
            if (typeof validationErrors.unknown === 'object') {
                Object.keys(validationErrors.unknown).forEach((columnId) => {
                    this.columns.forEach((column) => {
                        if (column.id === columnId) {
                            errorMessages.push(column.title + ' is unknown.');
                        }
                    });
                });
            }

            this.showMessage(errorMessages.join("\n"), 'error', popupShowTime);
            this.$refs.cedexDependencies.setValidationErrors(validationErrors.empty);
        },
        showMessage(content, type, close, buttonText) {
            this.messages.push({
                content:         content,
                type:            type,
                closeTimeout:    typeof close === 'number' ? close : -1,
                closeButtonText: buttonText ? buttonText : 'ok'
            });
        },
        filterDependencies(filters, showResultGroup) {
            this.updateView('filters', filters, showResultGroup);
        },
        exportDependencies: function()
        {
            if (Object.keys(this.dependencies).length === 0) {
                this.showMessage(i18n.t('Please select a Survey Type first.'), 'info', popupShowTime);
                return;
            }
            if (
                this.surveyTypes[this.layoutValue] !== 'Dry Box 20'
                && this.surveyTypes[this.layoutValue] !== 'Dry Box 40'
                && this.surveyTypes[this.layoutValue] !== 'Dry Box 45'

            ) {
                this.showMessage(i18n.t('Only Dry Box 20, 40 and 45 can be exported for now.'), 'info', popupShowTime);
                return;
            }
            // iterate through this.dependencies object
            // isoCode, locationCode, componentCode, materialCode, damageCode, repairCode, inspectionCriteria

            // convert object into data
            let columns = [
                'isoCode',
                'locationCode',
                'componentCode',
                'materialCode',
                'damageCode',
                'repairCode',
                'inspectionCriteria',
                'laborScaling',
                'materialScaling',
                'length',
                'width',
            ];
            let inspectionCriteriaAllValues = Object.values(this.inspectionCriteria);
            let columnData = {};
            let exportData = [[
                'ISO Code',
                'Location Code',
                'Location Description',
                'Component Code',
                'Component Code Name',
                'Component Description',
                'Damage Code',
                'Damage Code Name',
                'Damage Description',
                'Repair Code',
                'Repair Code Name',
                'Repair Description',
                'Inspection Criteria',
                'Labor Scaling',
                'Material Scaling',
                'Length',
                'Width',
            ]];
            let createCsvArray = (data) => {
                data.isoCode.forEach((isoCode) => {
                    data.locationCode.forEach((locationCode) => {
                        data.inspectionCriteria.forEach((inspectionCriteria) => {
                            if (inspectionCriteria === 'IICL (ECS)') {
                                inspectionCriteria = 'IICL';
                            }

                            exportData.push([
                                isoCode,
                                locationCode,
                                this.$refs.cedexDependencies.locationDescriptions(locationCode),
                                data.componentCode[0],
                                this.componentCodes[data.componentCode[0]],
                                this.codeDescriptions.component[data.componentCode[0]],
                                data.damageCode[0],
                                this.damageCodes[data.damageCode[0]],
                                this.codeDescriptions.damage[data.damageCode[0]],
                                data.repairCode[0],
                                this.repairCodes[data.repairCode[0]],
                                this.codeDescriptions.repair[data.repairCode[0]],
                                this.inspectionCriteria[inspectionCriteria],
                                data.laborScaling[0],
                                data.materialScaling[0],
                                data.length === '1' ? 'Yes' : 'No',
                                data.width === '1' ? 'Yes' : 'No',
                            ]);
                        });
                    });
                });
            };
            let convert = (currentData, column) => {
                if (column === 'inspectionCriteria') {
                    // complete exported data
                    let inspectionCriteria = currentData[column];
                    if (inspectionCriteria === null) {
                        inspectionCriteria = inspectionCriteriaAllValues;
                    } else {
                        inspectionCriteria = inspectionCriteria.split(',');
                    }
                    columnData[column] = inspectionCriteria;
                    columnData.laborScaling = currentData.laborScaling;
                    columnData.materialScaling = currentData.materialScaling;
                    columnData.length = currentData.length;
                    columnData.width = currentData.width;

                    // write data to export array
                    createCsvArray(columnData);
                } else {
                    // dive deeper
                    Object.keys(currentData).forEach((key) => {
                        // add current key to exportData
                        let currentValues = [];
                        if (key === '') {
                            // all values
                            let allValues = this[column + 's'];
                            if (allValues) {
                                currentValues = Object.keys(allValues);
                            }
                        } else {
                            currentValues = key.split(',');
                        }

                        columnData[column] = currentValues;
                        // next level
                        convert(currentData[key], columns[columns.indexOf(column) + 1]);
                    });
                }
            };
            convert(this.dependencies, 'isoCode');

            // Build csv file
            const csvContent = exportData.map(row => '"' + row.join('","') + '"').join('\n');
            // Create a Blob object for the CSV content
            const blob = new Blob([csvContent], { type: 'text/csv' });
            // Create a temporary download link
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'CEDEX Syntax ' + this.surveyTypes[this.layoutValue];
            // Simulate a click on the link to start the download
            document.body.appendChild(link);
            link.click();
            // Clean up the temporary download link
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        },
        updateComment(dependencyId, userId, userComment) {
            if (userComment) {
                this.$set(this.comments, userId, userComment);
            } else {
                this.$delete(this.comments, userId);
            }
        }
    },
    computed: {
        componentCodes() {
            if (!this.initialData.componentsWithContainerModule) {
                return {};
            }
            return this.initialData.componentsWithContainerModule[this.equipment];
        },
        surveyTypes() {
            if (!this.initialData.surveyTypesWithContainerModule) {
                return {};
            }
            return this.initialData.surveyTypesWithContainerModule[this.equipment];
        },
        locationCodes() {
            if (!this.initialData.locationCodesWithContainerModule) {
                return {};
            }
            return this.initialData.locationCodesWithContainerModule[this.equipment];
        },
        isoCodes() {
            if (!this.initialData.equipmentsWithIsoCodes) {
                return {};
            }
            return this.initialData.equipmentsWithIsoCodes[this.equipment];
        }
    }
}
</script>